import Image from 'next/image'

import contentfulImage from '../../utils/contentful-image'
import { ButtonCms, ButtonCmsModel } from '../button/button.cms'
import { RichText } from '../helper-components/rich-text'

export interface BrandCardProps {
  __typename: string
  sys: {
    id: string
  }
  brandTitle: string
  icon: {
    url: string
  }
  logo: {
    url: string
  }
  brandVertical: {
    title: string
    color: any
  }
  description: {
    json: any
  }
  button: ButtonCmsModel
}

export const BrandCardCMS = ({ card }: { card: BrandCardProps }) => {
  return (
    <div className="bg-white border border-tan-150 p-6 h-full flex flex-col">
      <div
        className="text-center text-neutral-700 font-medium uppercase text-xs mb-2"
        style={{ letterSpacing: '1px' }}
      >
        {card.brandVertical.title}
      </div>

      <div className="flex justify-center mb-6">
        <div
          className="w-[67px] h-[4px]"
          style={{ backgroundColor: card.brandVertical?.color?.value }}
        />
      </div>

      {card.logo ? (
        <div className="flex justify-center mt-3 mb-2">
          <img
            style={{ objectFit: 'contain' }}
            src={contentfulImage(card.logo.url)}
            alt={card.brandTitle + ' logo'}
            className="max-w-[254px]"
          />
        </div>
      ) : (
        <div className="flex justify-center gap-3 items-center">
          <Image
            width="53"
            height="53"
            src={contentfulImage(card.icon.url)}
            alt={card.brandTitle + ' icon'}
            style={{
              objectFit: 'contain',
            }}
          />

          <div className="font-bold text-lg text-[#231F20]">
            {card.brandTitle}
          </div>
        </div>
      )}

      <div className="text-neutral-800 text-base leading-[180%] mt-4 font-normal text-center">
        <RichText json={card.description.json} />
      </div>

      <div className="flex-1" />

      <div className="flex justify-center">
        <ButtonCms
          content={card.button}
          className="mt-14 min-w-[194px] border-navy border bg-white text-navy hover:bg-neutral-100 focus:outline-dashed"
        />
      </div>
    </div>
  )
}
